import React from "react";
import { UserVideoWord } from "@shared_types";
import Translation from "../Subtitles/Translation.tsx";
import Subtitle from "./ReviewSubtitle.tsx";

interface ReviewContentProps {
  currentTime: number;
  contextText: UserVideoWord[];
  reviewWord: UserVideoWord;
  targetWord: string;
  nativeWord: string;
  isFlipped: boolean;
  onWordClick: (clickedWord: UserVideoWord) => void;
  isDisplayHelp: boolean;
}

const ReviewCard: React.FC<ReviewContentProps> = ({
  currentTime,
  contextText,
  reviewWord,
  targetWord,
  nativeWord,
  isFlipped,
  onWordClick,
  isDisplayHelp,
}) => {
  const highlightIndex = calcDisplayIndex(currentTime, contextText);

  const reviewWordText = reviewWord.displayText.endsWith(".")
    ? reviewWord.displayText.slice(0, -1)
    : reviewWord.displayText;

  return (
    <div
      className={`max-h-80 relative flex flex-col flex-grow justify-start w-full rounded-xl sm:p-2 bg-[#fafafa]`}
    >
      <div className="w-full font-bold pb-2 text-lg">
        {!isFlipped ? (
          <>
            What does{" "}
            <span className="bg-[var(--color-yellow)] mx-1 rounded-sm px-[2px]">
              {reviewWordText}
            </span>{" "}
            mean? 🤔
          </>
        ) : (
          "How was that? 👀"
        )}
      </div>
      {!isFlipped ? (
        <>
          <Subtitle
            reviewWord={reviewWord}
            highlightIndex={highlightIndex}
            userVideoWords={contextText}
            onWordClick={onWordClick}
          />
          {isDisplayHelp ? null : (
            <div className="pt-3">
              <Translation targetWord={targetWord} nativeWord={nativeWord} />
            </div>
          )}
        </>
      ) : (
        <div className="flex flex-col w-full items-start justify-start gap-2">
          <div className="text-lg font-semibold text-black">
            <span className="bg-[var(--color-blue)] text-white px-1">
              {'"' + reviewWordText + '"'}
            </span>
            {" - " + reviewWord.definition.nativeWord}
          </div>
          <div className="text-start">{reviewWord.clickHint}</div>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;

type ArrWithStartTimes = UserVideoWord;
// For a given time and array on this page, we can calcualte the index of
// a word we want to show.
function calcDisplayIndex(time: number, arr: ArrWithStartTimes[]) {
  for (let i = 0; i < arr.length; i++) {
    const v = arr[i];
    if (time >= v.start) {
      continue;
    } else if (i === 0) {
      return i;
    } else {
      return i - 1;
    }
  }
  return arr.length - 1;
}
